export class NoScopedLogger {
    static instance = new NoScopedLogger();
    $name = 'no-scoped-logger';
    constructor() {
    }
    debug(_obj) { }
    error(_obj) { }
    info(_obj) { }
    fork() {
        return new NoScopedLogger();
    }
    mergeIn(_logger) { }
    print(_logger) { }
    toLog() {
        return null;
    }
    toLogs() {
        return [];
    }
}
//# sourceMappingURL=no-scoped-logger.js.map